import { Directive,EventEmitter,HostListener,Input, Output} from '@angular/core';

@Directive({
  selector: '[appZipCode]'
})
export class ZipCodeDirective {

  constructor() { }
  @Input('appZipCode') date:String;
  @Output() length = new EventEmitter();
  @HostListener('keypress', ['$event']) onkeypress(ev) {
    let valid = false;


    if(ev.target.value.length <= 4){

      if ((ev.charCode >= 48 && ev.keyCode <= 57)) {
        valid = true;
      }
      if ((ev.charCode == 46 || ev.charCode == 44)) {
        valid = true;
      }
      if (!valid) {
        ev.preventDefault();
      }
      this.length.next("5")
    }

    if(ev.target.value.length ==5){
      if ((ev.charCode == 45 )) {
        valid = true;
        this.length.next("10")

      }
      if ((ev.charCode == 46 || ev.charCode == 44)) {
        valid = true;
      }
      if (!valid) {
        ev.preventDefault();
      }

    }

    if(ev.target.value.length > 5){

      if ((ev.charCode >= 48 && ev.keyCode <= 57)) {
        valid = true;
      }
      if ((ev.charCode == 46 || ev.charCode == 44)) {
        valid = true;
      }
      if (!valid) {
        ev.preventDefault();
      }
    }
  }

  @HostListener('blur', ['$event']) onblur(event) {
    if (event.target.value != undefined && event.target.value != "") {

    }
  }
  @HostListener('keyup', ['$event']) onkeyup(event) {
    if (event.target.value != undefined && event.target.value != "") {
      // let valid = false;

      if(event.target.value.length ==5){
          this.length.next("5")
      }
    }
  }
}

